import { useForm } from "react-hook-form";
import {
  IEmployeeWizardFormModel,
  employeeWizardFormDefaultValues,
  employeeWizardFormSchema,
} from "../models/employeeWizardFormModel";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { Default_Instructor_Color } from "../../../../../common/infrastructure/utilities/colorUtility";
import { useFormValidationMessages } from "../../../../../common/infrastructure/hooks/useFormHelper";

export const useEmployeeWizardForm = (
  employee?: IEmployeeWizardFormModel
) => {
  const form = useForm<IEmployeeWizardFormModel>({
    defaultValues: employeeWizardFormDefaultValues,
    resolver: yupResolver(employeeWizardFormSchema),
  });

  useEffect(() => {
    if (employee) {
      form.setValue("id", employee.id);
      form.setValue("firstName", employee.firstName);
      form.setValue("lastName", employee.lastName);
      form.setValue("phoneNumber", employee.phoneNumber);
      form.setValue("email", employee.email);
      form.setValue("role", employee.role);
      if (employee.color) {
        form.setValue(
          "color",
          !!employee.color ? employee.color : Default_Instructor_Color
        );
      }
      form.setValue("viewOnlyOwnEvents", employee.viewOnlyOwnEvents ?? false);
      form.setValue("lockOthersEvents", employee.lockOthersEvents ?? false);

      if (employee.studios) {
        form.setValue("studios", employee.studios);
      }
    }
  }, [employee]);

  useFormValidationMessages<IEmployeeWizardFormModel>(form);

  return form;
};
